import script from "./Inventory.vue?vue&type=script&setup=true&lang=ts"
export * from "./Inventory.vue?vue&type=script&setup=true&lang=ts"

import "./Inventory.vue?vue&type=style&index=0&id=65cf5d03&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65cf5d03"]])

export default __exports__